/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import Navbar from './Navbar'
import Footer from './Footer'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'images/themify-icon/themify-icons.css'
import '../../static/styles/main.scss'

// Do this to circumvent the "invalid prop `query`" error
// https://github.com/birkir/gatsby-source-prismic-graphql/issues/77
const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Layout = ({ disableFooter, children }) => (
  <StaticQuery
    query={`${query}`}
    render={(data) => (
      <>
        <Navbar siteTitle={data.site.siteMetadata.title} />
        <main>{children}</main>
        {!disableFooter ? (<Footer />) : null}
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  disableFooter: PropTypes.bool
}

export default Layout
